<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable max-width="600">
      <v-card color="white">
        <v-card-title dark class="elevation-2">
          <span>Pending Remarks</span>
          <v-spacer></v-spacer>
          <v-btn color="black" icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 500px" class="my-2">
          <v-row>
            <v-col cols="12">
              <v-timeline reverse dense>
                <v-timeline-item
                  v-for="n in list"
                  :key="n.id"
                  color="#6DB249"
                  icon="mdi-comment-processing-outline"
                  fill-dot
                >
                  <v-card
                    class="elevation-2"
                    :class="
                      viewFrom == 'Owner' && n.isOpenned == 0
                        ? 'green white--text'
                        : ''
                    "
                  >
                    <div class="pa-2">
                      <div
                        class="text-subtitle-1 py-2"
                        style="line-height: 10px"
                      >
                        <div class="my-2">
                          {{ n.message }}
                        </div>
                        <div class="font-weight-bold text-caption mt-6">
                          {{ getUserName(n.remarks_maker_userID) }}
                        </div>
                        <div class="" style="font-size: 10px">
                          {{ formatDate(n.createdAt) }}
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="close()">
              cancel
            </v-btn>

            <v-btn
              color="green"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
              class="white--text"
              @click="handleSave()"
            >
              Save
            </v-btn>
          </v-card-actions> -->
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    viewFrom: null,
  },
  components: {},
  data() {
    return {
      dialog: false,
      remarksMsg: null,
      isSubmitLoading: false,
      list: [],
      users: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        if (data.length > 0) {
          //   this.remarksMsg = null;
          this.list = data;
          this.getUsers();
          this.dialog = true;
          if (this.viewFrom == "Owner") {
            this.setOpenned();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("closeRemarksTimeline", null);
    },

    getUsers() {
      this.axiosCall("/user-details/getAllUserDetail", "GET").then((res) => {
        this.users = res.data;
      });
    },

    getUserName(id) {
      let userID = this.$store.getters.getUserData.id;
      if (id == userID) {
        return "You";
      } else {
        if (this.users.length > 0) {
          let idx = this.users.findIndex((u) => u.id == id);
          return this.toTitleCase(this.users[idx].name);
        }
      }

      return;
    },

    setOpenned() {
      let toUpdate = [];
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].isOpenned == 0) {
          toUpdate.push(this.list[i]);
        }
      }

      if (toUpdate.length > 0) {
        let data = {
          list: JSON.stringify(toUpdate),
        };
        this.axiosCall("/remarks/set-openned-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              console.log("CAlled");
            } else if (res.data.status == 400) {
              console.log("err");
            }
          }
        );
      }
    },

    handleSave() {
      this.isSubmitLoading = true;
      if (this.$refs.PendingRemarksFormref.validate()) {
        let data = {
          module_from: this.moduleFrom,
          id_to_remark: this.data.id,
          type_of: this.type,
          message: this.remarksMsg,
        };

        this.axiosCall("/remarks/set-pending-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.isSubmitLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.$emit("saveRemarks", data);
              this.dialog = false;
              // this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },
  },
};
</script>
